export const membershipTiers = [
  {
    name: 'Private',
    line: 'One partner for your life, your family and every door you wish to open.',
    cta: 'Await your introduction',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/40b1acce-7324-4dd4-aa13-1c7dd87a645d.jpg',
    alt: 'A couple in evening wear stepping from a wooden motorboat onto a lantern-lit villa jetty at blue hour',
    href: '/membership',
  },
  {
    name: 'Corporate',
    line: 'Access, hospitality and discretion for founders, boards and their guests.',
    cta: 'Introduce your house',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/01722f86-376b-444f-a821-ace6ffd9bc54.jpg',
    alt: 'A woman in a tailored black coat walking toward a private jet at dusk',
    href: '/membership',
  },
  {
    name: 'Editorial',
    line: 'For houses and talent whose image is told only where it deserves to be seen.',
    cta: 'Request a private audience',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0d5bc49d-5a0b-48d4-9111-fd319b5fbd1e.jpg',
    alt: 'A model in a white gown photographed on a cliffside villa terrace at golden hour',
    href: '/membership',
  },
];
